// JavaScript Document
//components/dashboard/Dashboard
import logo from '../../logo.png';
//import '../../App.css';
import React from 'react';



export default function Dashboard() {
	
  return (
    <div>
	        <header className="App-header">
        	  <img src={logo} className="App-logo" alt="logo" />
        	  <p>
          		VSpeed™Online 2.0
        	  </p>
      		</header>
    </div>
  );
}
